import { Button, Modal } from "react-bootstrap"

const WorkspaceLockModal = ({
    show = false,
    title = 'Workspace is Locked',
    body_text = 'Please contact admin for assistance.',
    handleClose
}) => {
    return(
        <Modal 
            show={show}
            centered
        >
            <Modal.Header className="border-0 p-3 pb-0">
                <Modal.Title >{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3 fw-500">
                <p className="fs-12px mb-3">{body_text}</p>
                <div className="d-grid">
                    <Button 
                        variant="gray" 
                        className="fw-500" 
                        onClick={handleClose}
                        size="sm"
                    >
                        Back
                    </Button>
                </div>                
            </Modal.Body>
        </Modal>

    )
}

export default WorkspaceLockModal